import axios from 'axios'
import {apiUrl} from '../../../config/env.js'
axios.defaults.withCredentials = true

export const getSelectMember = (ShainNo, ShainName, DeptId, DivisionId, GroupId,
  HireOnStart, HireOnEnd, PostId, PointOfTime) => {
  return axios.post(apiUrl + '/user/selectMember', {
    'shain_no': ShainNo - 0,
    'shain_name': ShainName,
    'dept_id': DeptId.map(Number),
    'division_id': DivisionId.map(Number),
    'group_id': GroupId.map(Number),
    'hire_on_start': HireOnStart,
    'hire_on_end': HireOnEnd,
    'post_id': PostId.map(Number),
    'point_of_time': PointOfTime
  })
}

export const AutoInputUserName = (shainNo) => {
  return axios.post(apiUrl + '/getShainName/' + shainNo)
}

export const getShainInfo = (ShainNo, Option) => {
  return axios.post(apiUrl + '/user/selective', {
    'shain_no': ShainNo - 0,
    'option': Option
  })
}

export const Search = (shainNo, shainName, selectAuthList) => {
  return axios.post(apiUrl + '/user', {
    'shain_no': shainNo - 0,
    'shain_name': shainName,
    'select_auth_list': selectAuthList.map(Number)
  })
}

export const selectOneRecordUser = (Hash) => {
  return axios.get(apiUrl + '/user/' + Hash)
}

export const edit = (ShainNo, AuthId) => {
  return axios.put(apiUrl + '/user/edit', {
    'shain_no': ShainNo,
    'auth_id': AuthId - 0
  })
}



// WEBPACK FOOTER //
// ./src/api/user/index.js